module.exports = __webpack_public_path__ + "assets/img/img-lecturer.820570a2.png";